import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M6.053 20.845a.75.75 0 0 0 1.06 1.06l8.934-8.933a1.374 1.374 0 0 0 0-1.944L7.114 2.095a.75.75 0 0 0-1.061 1.06L14.898 12l-8.845 8.845z' />
  </svg>
);
